import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { push } from 'react-router-redux';

class SidebarDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select(event) {
		this.props.dispatch(push('/api/' + event.target.value));
	}

	render() {
		const { categories, selectedCategoryName } = this.props;
		const CategoryLinks = categories.map((category, index) =>
			<option key={category.name}
				className={category.name === selectedCategoryName ? 'route-links' : ''} >
				{category.name}
			</option>
		);
		return (
			<div className='dropdown-container'>
				<select className='dropdown-list' onChange={this.select}>
					{CategoryLinks}
				</select>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;

	if (match) {
		const { category } = match.params;

		return {
			selectedCategoryName: category
		};
	}

	return {};
};

SidebarDropdown.propTypes = {
	categories: PropTypes.array.isRequired,
	selectedCategoryName: PropTypes.string,
	dispatch: PropTypes.func.isRequired
};

export default withRouter(connect(mapStateToProps)(SidebarDropdown));


// WEBPACK FOOTER //
// ./src/components/api/SidebarDropdown.js